import ujs from '@rails/ujs';
import enableTippy from './src/js/enable-tippy';
import initAutoRedirect from './src/js/js-auto-redirect';

ujs.start();

document.addEventListener('DOMContentLoaded', () => {
  enableTippy();
  initAutoRedirect();
});
